import React from "react";
const LoginSignupSide = ({ type, heading, text }) => {
  // SIDE OF LOGIN PANEL
  return (
    <>
      <div className="flapper"></div>
      <div className={`login_side_container ${type}`}>
        <div className="side_content_wrapper">
          <div className="motion_content text-center">
            <div className="text_login_wrapper">
              <h1 className="text-white font-weight-bold">{heading}</h1>
              <p className="login_text">{text}</p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default LoginSignupSide;
